// extracted by mini-css-extract-plugin
module.exports = {"cell":"BrandsColumns_cell__2h-2f","cellWithImg":"BrandsColumns_cellWithImg__10GKT","cellImg":"BrandsColumns_cellImg__2DZ_J"};